import { Tooltip } from '@fluentui/react-components'
import { RESOLUTION_INFO } from '../lib/personRows'
import Lozenge from './Lozenge'
import type { ResolutionKind } from '../types'

/** Shown on both the Licenses tab and the User links tab (per-service) — same badge either
 * place, so "Manually linked" (etc.) always means the same thing regardless of which tab it's
 * seen on. */
export default function ResolutionBadge({ kind }: { kind: ResolutionKind }) {
  const info = RESOLUTION_INFO[kind]
  return (
    <Tooltip content={info.hint} relationship="description" withArrow>
      <Lozenge color={info.color}>{info.label}</Lozenge>
    </Tooltip>
  )
}
